import React from 'react';
// import DefaultLayout from './containers/DefaultLayout';

const Contact = React.lazy(() => import('./views/Contact/Contact'));
const About = React.lazy(() => import('./views/AboutUs/AboutUs'));
const PrivacyPolicy = React.lazy(() => import('./views/PrivacyPolicy/PrivacyPolicy'));
const TermsAndCondition = React.lazy(() => import('./views/TermsAndCondition/TermsAndCondition'));
const AgilityThinking = React.lazy(() => import('./views/AgilityThinking/AgilityThinking'));
const Video = React.lazy(() => import('./views/Videos/Video.js'));
const SeoPage = React.lazy(() => import('./views/SeoPages/SeoPage.js'));
const SolitaryEvent = React.lazy(() => import('./views/Events/SolitaryEvent'));
const SolitaryGroup = React.lazy(() => import('./views/Events/SolitaryGroup'));
const Blog = React.lazy(() => import('./views/Blogs/Blog'));

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: '/contact', name: 'Contact', component: Contact },
  { path: '/about-us', name: 'About', component: About },
  { path: '/privacy-policy', name: 'PrivacyPolicy', component: PrivacyPolicy },
  { path: '/terms-and-conditions', name: 'TermsAndCondition', component: TermsAndCondition },
  { path: '/events/:name', name: 'SolitaryEvent', component: SolitaryEvent },
  { path: '/groups/:name', name: 'SolitaryGroup', component: SolitaryGroup },
  { path: '/videos/:video_name', name: 'Video', component: Video },
  { path: '/blogs/:title', name: 'Blog', component: Blog },
  { path: '/:url', name: 'SeoPage', component: SeoPage },
  { path: '/', exact: true, name: 'Home', component: AgilityThinking }
];

export default routes;
